import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AnimatedSection } from './ui/AnimatedSection';
import { ChevronDown, HelpCircle } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cuánto tiempo necesito para ver resultados?',
    a: 'Inmediatamente. La técnica de reinicio funciona de forma biológica desde la primera vez que la aplicas correctamente.'
  }, {
    q: '¿Tengo que leer todo el libro para empezar?',
    a: 'No. El Capítulo 2 contiene la técnica de emergencia para que puedas usarla hoy mismo.'
  }, {
    q: '¿Funciona si mis hijos son adolescentes?',
    a: 'Sí. Aunque los ejemplos se enfocan en la niñez, la biología del estrés parental es la misma sin importar la edad de los hijos.'
  }, {
    q: '¿Es un producto físico?',
    a: 'Es un bundle digital descargable en PDF, optimizado para leer en tu móvil en los pocos minutos libres que tienes.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <AnimatedSection className="bg-white" data-id="element-26">
      <div className="max-w-3xl mx-auto" data-id="element-27">
        <div className="text-center mb-12 flex flex-col items-center" data-id="element-28">
          <div className="bg-mint-light text-mint-dark p-3 rounded-full mb-4" data-id="element-29">
            <HelpCircle className="w-8 h-8" data-id="element-30" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-31">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-32">
          {faqs.map((faq, index) => <div key={index} className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${openIndex === index ? 'border-mint bg-mint-light/10 shadow-sm' : 'border-gray-200 bg-white hover:border-mint-light'}`} data-id="element-33">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-34">
                <span className="font-bold text-lg text-charcoal pr-8" data-id="element-35">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-mint-dark flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-36" />
              </button>

              <AnimatePresence data-id="element-37">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-38">
                    <div className="px-6 pb-5 text-charcoal-light text-lg leading-relaxed border-t border-mint-light/30 pt-4" data-id="element-39">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </AnimatedSection>;
}